// @flow
import React, { memo } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { TableRow, TableRowColumn } from 'material-ui/Table';

const VocabularyListItem = memo(props => {
	const { item, handleClick } = props;
	const { id, name, value, description, canDelete } = item;
	const renderBoolean = value => (value ? 'Да' : 'Нет');
	return (
		<TableRow onClick={() => handleClick(id)}>
			<TableRowColumn>{name}</TableRowColumn>
			<TableRowColumn>{value}</TableRowColumn>
			<TableRowColumn>{description}</TableRowColumn>
			<TableRowColumn>{renderBoolean(canDelete)}</TableRowColumn>
		</TableRow>
	);
});

export default createFragmentContainer(VocabularyListItem, {
	item: graphql`
		fragment vocabularyListItem_item on Vocabulary {
			id
			name
			value
			description
			canDelete
		}
	`,
});



// WEBPACK FOOTER //
// src/components/vocabulary/vocabulary-list-item.js